export default __webpack_public_path__ + "static/media/email.87d73b60.png";